class HeaderDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector(".main-details");
    this.childDetailsToggles = this.querySelectorAll(".child-details");
    this.coverElement = document.getElementById('header__cover');
    if (this.mainDetailsToggle) {
      this.mainDetailsSummary = this.mainDetailsToggle.querySelector("summary");
    }

    // Event Listeners
    this.addEventListener('keyup', this.onKeyUp);

    if (this.mainDetailsToggle) {
      this.mainDetailsSummary.addEventListener('click', (event) => {
        // Don't redirect for keyboard users pressing enter, since enter key should be used for navigation
        const detailHref = this.mainDetailsToggle.dataset.href;
        if (detailHref && event.detail !== 0) {
          event.preventDefault();
          if (detailHref !== '#') {
            location.href = detailHref;
          }
        }
      });

      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('mouseenter', this.onHover.bind(this));
      this.mainDetailsToggle.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {      
          if (event.target.ariaExpanded === 'false') {
            this.openCover();
          } else {
            this.closeCover();
          }
        }
      });
    }  

    this.childDetailsToggles.forEach( childDetail => {
      const childDetailsSummary = childDetail.querySelector("summary");

      childDetailsSummary.addEventListener('click', (event) => {
        // Don't redirect for keyboard users pressing enter, since enter key should be used for navigation
        const detailHref = childDetail.dataset.href;
        if (detailHref && event.detail !== 0) {
          event.preventDefault();
          if (detailHref !== '#') {
            location.href = childDetail.dataset.href;
          }
        }
      });

      childDetail.addEventListener('focusout', this.onFocusOut.bind(this));

      // (JIRA DIG-67  Add delay to hover on navigation)
      
      var timer;
      childDetail.addEventListener('mouseenter', (event) => {
        timer = setTimeout(()=> {
          childDetail.classList.add('hovered');
          this.closeAllL2();
          childDetail.setAttribute('open', true);
        }, 250);
      });
      
      childDetail.addEventListener('mouseleave', (event) => {
        clearTimeout(timer);
        childDetail.classList.remove('hovered');
      });

      // childDetail.addEventListener('mouseenter', () => {
      //   this.closeAllL2();
      //   childDetail.setAttribute('open', true);
      // });

      childDetail.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {          
          this.closeAllL2(childDetail);
        }
      });
    });
  }

  closeAllL2(exlcludedL2) {
    this.childDetailsToggles.forEach((details) => {
      if (details !== exlcludedL2) {  
        details.removeAttribute('open');
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onHover(event) {
    event.preventDefault();
    this.open(event);
  }

  onMenuClose(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.openCover();

    let parentDetail = event.target.closest('.main-details');
    parentDetail.setAttribute('open', true);

    this.childDetailsToggles.forEach((details) => {
      details.removeAttribute('open');
    });

    let firstChild = this.childDetailsToggles[0]
    if (firstChild) {
      firstChild.setAttribute('open', true);
    } 

    this.onMenuCloseEvent =
    this.onMenuCloseEvent || this.onMenuClose.bind(this);
    document.body.addEventListener('click', this.onMenuCloseEvent);
    document.body.addEventListener('mouseover', this.onMenuCloseEvent);

    
    trapFocus(
      parentDetail.querySelector('.header__submenu-contents')
    );
  }

  close(focusToggle = true) {
    this.closeCover();
    removeTrapFocus(focusToggle ? this.mainDetailsToggle : null);

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute('open');
    }
    document.body.removeEventListener('click', this.onMenuCloseEvent);
    document.body.removeEventListener('mouseover', this.onMenuCloseEvent);
  }

  openCover() {
    this.coverElement.classList.add('header__cover--open');
  }

  closeCover() {
    this.coverElement.classList.remove('header__cover--open');
  }
}

customElements.define('header-details-disclosure', HeaderDetailsDisclosure);
